import { clearCache } from './url';
import { messages } from '@/config';
import scriptjs from 'scriptjs';
import Vue from 'vue';

const vm = new Vue();

const JDBRIDGE = window.location.protocol + '//m.jr.jd.com/statics/jdShare.min.js';
const WEIXINBRIDGE = window.location.protocol + '//m.jr.jd.com/statics/WeixinApi.min.js';

/**
 *
 * 配置右上角分享
 **/
export function shareInit(options = {}) {
  const { url, imgSrc, title, desc, channels, links } = getShareObject(options);
  if (!title) {
    return false;
  }
  /*
   * 金融app分享
   * **/
  if ($.device && $.device.jdjr && !options.hideNativeShare) {
    const _channels = channels || ['0', '1', '3'];
    let _links = links || [];
    if (!_links || _links.length === 0) {
      _links = [];
      _channels.map(() => {
        _links.push(url);
      });
    }
    //分享部分
    const jdjrShareData = {
      isShow: true, //true 显示btn，false 隐藏btn,默认隐藏
      optionType: 1, //1:分享，2:连接跳转类型，3：跳原生模块
      btnText: '分享', //原生按钮显示的文字
      shareDate: {
        appId: '123',
        img: imgSrc,
        link: url,
        title: title,
        desc: desc,
        friendesc: desc,
        type: '1'
      },
      shareDataNew: {
        //以上是老版分享内容配置，这个字段是新版分享内容配置
        isLogin: '0',
        id: '5',
        linkSubtitle: desc, //副标题
        imageUrl: imgSrc, // 图片链接必须是https开头
        link: _links, //协议头必须是https开头
        linkTitle: title, //主标题
        //分享渠道，0-微信朋友圈，1-微信好友，3-短信，4-QQ好友，5-QQ空间
        channels: _channels
      }
    };

    // console.log(jdjrShareData);
    const stt = setTimeout(() => {
      clearTimeout(stt);
      window.jsBridgeV3 &&
        window.jsBridgeV3.onReady().then(function(res) {
          if (res && res.jsToNaWeiXin) {
            res.jsToNaWeiXin(jdjrShareData);
          }
        });
    }, 200);
  }

  /*
   * 微信分享
   * **/
  if ($.device && $.device.weixin) {
    scriptjs(WEIXINBRIDGE, () => {
      if (window.WeixinApi && !options.hideWeiXinShare) {
        const weixinShareData = {
          appId: '',
          title: title, // 分享标题
          desc: desc, // 分享描述
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          link: url, // 分享链接
          imgUrl: imgSrc, // 分享图标
          success: function() {
            // 用户确认分享后执行的回调函数
          },
          cancel: function() {
            // 用户取消分享后执行的回调函数
          }
        };

        // console.log('weixinShareData', weixinShareData);
        window.WeixinApi.ready(function(api) {
          const wxCallbacks = {
            ready: function() {},
            // 取消分享
            cancel: function() {
              vm.$toast.show({ text: '取消分享' });
              $(document)
                .find('.cls-popContainer')
                .remove();
            },
            fail: function() {},
            // 分享成功
            confirm: function() {
              vm.$toast.show({ text: '分享成功' });
              $(document)
                .find('.cls-popContainer')
                .remove();
            },
            all: function() {}
          };

          api.shareToFriend(weixinShareData, wxCallbacks);
          api.shareToWeibo(weixinShareData, wxCallbacks);
          api.shareToTimeline(weixinShareData, wxCallbacks);
        });
      }
    });
  }

  // 商城分享
  if ($.device && $.device.jdapp) {
    let jdImg = 'https://img12.360buyimg.com/jrpmobile/jfs/t28069/118/1531685442/19730/8e0317ae/5ce36be5Nf2ce9f2c.png';
    let os = (function() {
      let device = '';
      let ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf('iphone') != -1) {
        device = 'iphone';
      } else if (ua.indexOf('android') != -1) {
        device = 'android';
      } else if (ua.indexOf('ipad') != -1) {
        device = 'ipad';
      }
      return device;
    })();
    let channel = '';
    channel = 'Wxfriends,Wxmoments';

    if (os === 'iphone') {
      window.location =
        'openApp.jdmobile://virtual?params={"category":"jump","des":"share","type":"111","title":"' +
        messages.shareTitle +
        '","content":"' +
        messages.shareDesc +
        '","shareUrl":"https://jddx.jd.com/m/jddnew/btyingxiao/sfstore/index.html","imageUrl":"' +
        jdImg +
        '","iconUrl":"' +
        jdImg +
        '","channel":"' +
        channel +
        '","isCallBack":"Y","shareActionType":"S"}';
    } else if (os === 'android') {
      if (window.shareHelper && window.shareHelper.initShare) {
        const stt = setTimeout(() => {
          clearTimeout(stt);
          window.shareHelper.initShare(
            JSON.stringify({
              shareUrl: 'https://jddx.jd.com/m/jddnew/btyingxiao/sfstore/index.html',
              iconUrl: jdImg,
              title: messages.shareTitle,
              content: messages.shareDesc,
              shareActionType: 'S',
              channel: channel,
              callback: 'Y',
              eventId: ''
            })
          );
        }, 100);
      }
    }
  }
  // end
}

/**
 * 手动启动分享
 * 比如点击“按钮”后启动
 */
export function shareOpen(config = {}) {
  config = $.extend(window.config || {}, config);
  const { url, imgSrc, title, desc, friendesc, showLayer, channels, links } = getShareObject(config);
  if (!$.device) {
    return;
  }

  // 京东商城
  if (!$.device.jdPadApp && $.device.jdapp) {
    scriptjs(JDBRIDGE, () => {
      window.jdShare.callSharePane({
        title,
        content: desc,
        url: url, //必须以https开头
        img: imgSrc, //必须以https开头
        channel: 'Wxfriends,Wxmoments',
        // 不要依赖回调，不要在回调中加入业务逻辑，不要在回调中处理耗时的操作 // ,Sinaweibo
        callback() {
          if ($.isFunction(config.success)) {
            config.success('JD');
          }
        }
      });
    });
  }

  // 微信
  if ($.device.weixin) {
    //增加遮罩层
    if (showLayer) {
      shareGuide();
    }
    // 配置微信分享
    shareInit(config);
  }

  // 金融app
  if ($.device.jdjr) {
    const _channels = channels || ['0', '1', '3'];
    let _links = links || [];
    if (!_links || _links.length === 0) {
      _links = [];
      _channels.map(() => {
        _links.push(url);
      });
    }

    const options = {
      type: 4,
      shareDate: {
        appId: '',
        img: imgSrc,
        link: url,
        title: title,
        desc: desc,
        friendesc: friendesc,
        type: ''
      },
      shareDataNew: {
        //以上是老版分享内容配置，这个字段是新版分享内容配置
        isLogin: '0',
        id: '5',
        linkSubtitle: desc, //副标题
        imageUrl: imgSrc, // 图片链接必须是https开头
        link: _links, //协议头必须是https开头
        linkTitle: title, //主标题
        //分享渠道，0-微信朋友圈，1-微信好友，3-短信，4-QQ好友，5-QQ空间
        channels: _channels
      }
    };

    const stt = setTimeout(() => {
      clearTimeout(stt);
      window.jsBridgeV3 &&
        window.jsBridgeV3.onReady().then(api => {
          console.log('jdjr share');
          if (api && api.jsToGetResp) {
            api.jsToGetResp(function(rst) {
              if ($.isFunction(config.success)) {
                config.success('JDJR', rst);
              }
            }, options);
          }
        });
    }, 100);
  }
}

/**
 *
 * 分享信息处理
 */
const getShareObject = options => {
  // 当前网址，分享图片地址，分享标题，分享描述，支持频道，自定义分享链接， 是否展示微信遮罩层
  const { shareURL, shareImgSrc, shareTitle, shareDesc, shareChannels, shareLinks, wxLayer } = options;
  const url = clearCache(shareURL || window.location.href);
  const imgSrc = clearCache(shareImgSrc);
  const title = shareTitle;
  const desc = shareDesc;
  const friendesc = title;
  const channels = shareChannels;
  const links = shareLinks;
  const showLayer = wxLayer || true; // 默认展示遮罩层

  return { url, imgSrc, title, desc, friendesc, channels, links, showLayer };
};

/**
 *
 * 微信渠道-增加遮罩层
 **/
export function shareGuide() {
  if ($.device && $.device.weixin) {
    $(document)
      .find('body')
      .append("<div class='cls-popContainer' onclick='javascript:$(this).remove()'><img src='images/share_out.png'/></div>");
  }
}

/**
 * 隐藏金融app分享
 */
export function HideShare(config) {
  try {
    if ($.device.jdjr && !config.hideNativeShare) {
      if (!config.backColor) {
        config.backColor = '#000000';
      }

      //分享部分
      const option = {
        version: 100,
        title: config.title || '', //设置webview的title。可以是图片，也可以是文字
        moreItem: config.moreItem, //是否展示，右上角 更多icon  true展示更多
        hideTools: config.hideTools || false, // 隐藏分享按钮，true 隐藏， false 不隐藏
        backColor: [config.backColor, config.backColor], //设置titile颜色，必须为6位16进制字符。支持渐变色（设置俩颜色），单一颜色（设置一个颜色值）
        textColor: config.textColor || 2, //选择标题颜色（1：白色，2：黑色）
        rightItemList: []
      };

      const stt = setTimeout(() => {
        clearTimeout(stt);
        window.jsBridgeV3 &&
          window.jsBridgeV3.onReady().then(api => {
            console.log('jdjr share', JSON.stringify(option));
            if (api && api.setNaviBar) {
              api.setNaviBar(option);
            }
          });
      }, 10);
    }
  } catch (e) {
    console.log(e);
  }
}

export function closeXview() {
  const stt = setTimeout(() => {
    clearTimeout(stt);
    console.log(1212211);
    window.jsBridgeV3 &&
      window.jsBridgeV3.onReady().then(api => {
        if (api && api.jsToGetResp) {
          api.jsToGetResp(
            function() {
              console.log(0);
            },
            { type: 10, alert: 1, alertData: { title: '确认关闭当前页面吗', message: '关闭页面将退出当前浏览，如果想返回上一页请使用APP或系统的返回键', cancleTitle: '继续浏览', sureTitle: '退出' } }
          );
        }
      });
  }, 100);
}
